import React from 'react';
import { FiArrowRight } from 'react-icons/fi';
import './UsaKidsClasses.css';

const UsaKidsClasses = ({ onOpenModal }) => {
  return (
    <section className="usa-kids-classes" id="kids-classes">
      <div className="usa-kids-classes__container">
        <div className="usa-kids-classes__grid">
          {/* Left Column: Copy */}
          <div className="usa-kids-classes__info">
            <h2 className="usa-kids-classes__title">
              Online Quran Classes For Kids In The USA With Safe, Structured & Effective Environment
            </h2>

            <p className="usa-kids-classes__desc">
              Muslim parents in the USA face a real challenge: their children are growing up in an environment where Islamic education is not built into the school system. Weekend Islamic schools are often inconsistent. Local masjid may not offer reliable online options. Al Quran Lesson was built specifically to solve this problem.
            </p>

            <p className="usa-kids-classes__desc">
              Our online Quran classes for kids are designed with children’s learning psychology in mind. Sessions are engaging, encouraging, and appropriately paced for young learners. Our tutors are trained to work with children of all temperaments, from highly motivated young students to reluctant beginners who need patience and motivation before they warm up.
            </p>

            <h3 className="usa-kids-classes__subheading">What parents in the USA tell us:</h3>
            <ul className="usa-kids-classes__list">
              <li>Their children look forward to Quran class, not dread it</li>
              <li>Progress is visible within the first month</li>
              <li>They have peace of mind knowing their child is learning correctly from a certified tutor</li>
              <li>The flexible scheduling means the Quran class fits around school and extracurriculars</li>
            </ul>

            <p className="usa-kids-classes__desc-bold">
              We accept students starting from age 4. The Noorani Qaida course is the perfect starting point for young beginners.
            </p>

            <button 
              onClick={onOpenModal}
              className="usa-kids-classes__cta-btn"
              style={{ border: 'none', cursor: 'pointer' }}
            >
              <span>Get Free Trial For Classes</span>
              <FiArrowRight className="usa-kids-classes__cta-arrow" />
            </button>
          </div>

          {/* Right Column: Image */}
          <div className="usa-kids-classes__image-container">
            <img
              src={`${process.env.PUBLIC_URL}/assets/images/g-5.jpg`}
              alt="Kid reading Quran on laptop"
              className="usa-kids-classes__img"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default UsaKidsClasses;
